import { makeAutoObservable, runInAction } from "mobx";
import Api from "../api/Api";
import {
  ApiResponse,
  Film,
  ApiResponsePremier,
  FilmPremier,
} from "../types/interfaces";
import { FilmFull, ApiResponseFilm } from "../types/interfacesonefilm";

class MoviesStore {
  movies: Film[] = [];
  moviesPremier: FilmPremier[] = [];
  loading = false;
  error: string | null = null;
  movie: FilmFull | null = null;

  currentPage = 1;
  totalPages = 1;
  limit = 14; // кол-во фильмов на страницу

  private lastPremierQuery: {
    page: number;
    cid?: number;
    filterString?: string;
  } | null = null;

  private lastPortalQuery: {
    page: number;
    cid?: number;
    filterString?: string;
  } | null = null;

  constructor() {
    makeAutoObservable(this);
    // при инициализации читаем limit из localStorage
    const savedLimit = localStorage.getItem("mediateka.Limit");
    if (savedLimit) {
      const num = Number(savedLimit);
      if (!isNaN(num) && num >= 1 && num <= 48) {
        this.limit = num;
      }
    }
  }
  setLimit(value: number) {
    if (value < 1) value = 1;
    if (value > 48) value = 48;
    this.limit = value;
    localStorage.setItem("mediateka.Limit", String(value));
  }

  async fetchMovies(page: number, cid?: number, filterString?: string) {
    // Сохраняем параметры последнего запроса
    this.lastPortalQuery = { page, cid, filterString };
    runInAction(() => {
      this.loading = true;
    });

    try {
      const body = {
        limit: this.limit,
        page,
        cid,
        ...(filterString
          ? Object.fromEntries(
              filterString.split("&").map((s) => {
                const [key, value] = s.split("=");
                return [key, value];
              })
            )
          : {}),
      };
      const response = await Api.post<ApiResponse>("/movies", body);

      runInAction(() => {
        this.movies = response.data.data;
        this.currentPage = page;
        this.totalPages = response.data.pagination.totalPages;
        this.error = null;
      });
    } catch (error) {
      console.error("Ошибка загрузки фильмов", error);
      const e = error as any; // 👈 приведение к any
      const message =
        e.response?.data?.error?.message ||
        e.response?.data?.message ||
        e.message ||
        "Неизвестная ошибка";

      alert(`Ошибка загрузки фильмов: ${message}`);
      runInAction(() => {
        this.error = message;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async fetchMovieById(movie_id: number) {
    runInAction(() => {
      this.loading = true;
    });

    try {
      const response = await Api.get<ApiResponseFilm>("/movies/info", {
        params: { movie_id },
      });
      runInAction(() => {
        this.movie = response.data.data;
        this.error = null;
      });
    } catch (error) {
      console.error("Ошибка загрузки фильмов", error);
      const e = error as any; // 👈 приведение к any
      const message =
        e.response?.data?.error?.message ||
        e.response?.data?.message ||
        e.message ||
        "Неизвестная ошибка";

      alert(`Ошибка загрузки фильмов: ${message}`);
      runInAction(() => {
        this.error = message;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async fetchMoviesPremier(page: number, cid?: number, filterString?: string) {
    // Сохраняем параметры последнего запроса
    this.lastPremierQuery = { page, cid, filterString };

    runInAction(() => {
      this.loading = true;
    });

    try {
      const response = await Api.get<ApiResponsePremier>("/movies/premier", {
        params: {
          limit: this.limit,
          page,
          cid,
          // Разбираем строку фильтров и добавляем к params
          ...(filterString
            ? Object.fromEntries(
                filterString.split("&").map((s) => {
                  const [key, value] = s.split("=");
                  return [key, value];
                })
              )
            : {}),
        },
      });

      runInAction(() => {
        this.moviesPremier = response.data.data;
        this.currentPage = page;
        this.totalPages = response.data.pagination.totalPages;
        this.error = null;
      });
    } catch (error) {
      console.error("Ошибка загрузки фильмов", error);
      runInAction(() => {
        this.error = "Ошибка загрузки фильмов";
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  // Универсальный повторитель последнего запроса к Premier
  async repeatLastPremierQuery() {
    if (!this.lastPremierQuery) return;
    const { page, cid, filterString } = this.lastPremierQuery;
    await this.fetchMoviesPremier(page, cid, filterString);
  }

  // Универсальный повторитель последнего запроса к Portal
  async repeatLastPortalQuery() {
    if (!this.lastPortalQuery) return;
    const { page, cid, filterString } = this.lastPortalQuery;
    await this.fetchMovies(page, cid, filterString);
  }
}

// экспортим готовый store
const moviesStore = new MoviesStore();
export default moviesStore;
